import React from 'react';
import { styled, makeStyles } from '@mui/styles';
import { Grid2, TableCell, TableRow, Tooltip } from '@mui/material';
import theme from '../../../../core/theme';
import { UsedIcon, UnusedIcon } from '../../../shared/components/AppIcons';
import { ContentResponse } from '../../../../data/types/content.interface';
import moment from 'moment';
import { last, upperFirst } from 'lodash';

const useStyles = makeStyles({
  hover: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  overflow: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&.filename': {
      width: '240px',
    },
    '&.title': {
      width: '200px',
    },
  },
  themeButtons: {
    width: '60px',
    height: '25px',
    display: 'flex',
    padding: '2px 0',
    justifyContent: 'center',
    borderRadius: '12px',
    alignItems: 'center',
    '&.travel': {
      border: '1px solid #C0F3C6',
      backgroundColor: '#E6FFE9',
      color: '#238E30',
    },
    '&.fun': {
      border: '1px solid #FCE68A',
      backgroundColor: '#FDF3C7',
      color: '#DD851C',
    },
    '&.learn': {
      border: '1px solid #BFDBFE',
      backgroundColor: '#DBEAFE',
      color: '#2863EB',
    },
  },
});

interface Props {
  index: number;
  content: ContentResponse;
  onRowClicked: () => void;
}

const StyledTableCell: any = styled(TableCell)(() => ({
  paddingTop: '12px',
  paddingBottom: '12px',
  borderBottom: `1px solid ${theme.palette.chipBg.main}`,
}));

const MarketingContentRow: React.FC<Props> = ({ content, onRowClicked }) => {
  const classes = useStyles();

  return (
    <>
      <TableRow key={content.id}>
        <StyledTableCell
          component="td"
          style={{ width: '180px' }}
          ole="button"
          className={classes.hover}
          onClick={onRowClicked}
        >
          <Tooltip title={content.filename}>
            <div className={`${classes.overflow} filename`}>{content.filename}</div>
          </Tooltip>
        </StyledTableCell>
        <StyledTableCell
          component="td"
          style={{ width: '120px' }}
          role="button"
          className={classes.hover}
          onClick={onRowClicked}
        >
          <div>{content.marketingPlatformDetails?.map((details) => details.platform).join(', ') || ''}</div>
        </StyledTableCell>
        <StyledTableCell
          component="td"
          style={{ width: '150px' }}
          role="button"
          className={classes.hover}
          onClick={onRowClicked}
        >
          <div className={`${classes.overflow} title`}>{content.title}</div>
        </StyledTableCell>
        <StyledTableCell
          component="td"
          style={{ width: '80px' }}
          role="button"
          className={classes.hover}
          onClick={onRowClicked}
        >
          <div
            className={`${classes.themeButtons} ${
              content?.theme === 'Travel' ? 'travel' : content?.theme === 'Fun' ? 'fun' : 'learn'
            }`}
          >
            {content.theme}
          </div>
        </StyledTableCell>
        <StyledTableCell
          component="td"
          style={{ width: '80px' }}
          role="button"
          className={classes.hover}
          onClick={onRowClicked}
        >
          <div className={`${classes.overflow}`}>{content.category || ''}</div>
        </StyledTableCell>
        <StyledTableCell
          component="td"
          style={{ width: '120px' }}
          role="button"
          className={classes.hover}
          onClick={onRowClicked}
        >
          <div className={`${classes.overflow}`}>{content.subCategory || ''}</div>
        </StyledTableCell>
        <StyledTableCell
          component="td"
          style={{ width: '120px' }}
          role="button"
          className={classes.hover}
          onClick={onRowClicked}
        >
          <div className={`${classes.overflow} title`}>{last(content?.pathLink?.split('/')) || ''}</div>
        </StyledTableCell>
        <StyledTableCell
          component="td"
          style={{ width: '100px' }}
          role="button"
          className={classes.hover}
          onClick={onRowClicked}
        >
          <div className={`${classes.overflow}`}>
            {content.marketingPlatformDetails
              ?.map((details) => details.publishedDate && moment(details.publishedDate).format('YYYY-MM-DD'))
              .join(', ')}
          </div>
        </StyledTableCell>
        <StyledTableCell component="td" style={{ width: '100px' }} alignItem="center">
          <Grid2 container direction="row" alignItems="center">
            <div>
              {content?.published ? (
                <span>
                  <UsedIcon viewBox="0 0 42 42" style={{ fontSize: '42px' }} />
                </span>
              ) : (
                <span>
                  <UnusedIcon viewBox="0 0 42 42" style={{ fontSize: '42px' }} />
                </span>
              )}
            </div>
            {upperFirst(content?.marketingPlatformDetails.map((details) => details.publishedStatus).join(', '))}
          </Grid2>
        </StyledTableCell>
      </TableRow>
    </>
  );
};

export default MarketingContentRow;
